var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TicketList',{attrs:{"fetch-fn":_vm.getRequests,"module-name":_vm.$constants.REQUEST,"scrollable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }